import React from "react";
import { Header, HeaderProps } from "@emisgroup/ui-dialog";

interface CustomHeaderProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
}

type HeadProps = HeaderProps & CustomHeaderProps;

/**
 * Responsible for rendering the dialog header component
 * @returns dialog header element
 */
export const UIHeader: React.FC<HeadProps> = (props: HeadProps) => {

  const { className, children } = props;

  return (
    <Header
      className={`${className} ui-dialog-header`}
      {...props}
    >
      {children}
    </Header>
  );
};
